import React from 'react';

import { Box, flameTheme, Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

const BannerOffendingRecordsCleaned = () => {
  const { colors } = flameTheme;

  return (
    <>
      <Flex flexDirection="column" flexWrap="wrap" width="70%" pr="5rem">
        <Box>
          <Text fontSize="21px" fontWeight="bold">
            All sensitive information has been cleaned
          </Text>
          <Text fontSize="1rem" mb={3} color={colors.textDimmed}>
            Your POS system has been cleaned and there&apos;s no further action required.
          </Text>
        </Box>
      </Flex>
      <Flex width="30%" justifyContent="center">
        <Box>
          <img src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/customer_data/success.png" alt="Success" width="100%" height="100%" />
        </Box>
      </Flex>
    </>
  );
};

export default BannerOffendingRecordsCleaned;
